import axios from "axios";
import Cookies from "js-cookie";
import { get_doc } from "./frappeService";

export const fetchUserDetails = () => {
	return get_doc({
		doc: "Customer",
		fields: [
			"first_name",
			"last_name",
			"email",
			"phone",
			"beta_feature_user",
			"scrap_saving_cost_enabled",
			"name",
			"company_name",
			"logo",
			"signed_source",
			//TODO: multi currency
			// "country",
			// "currency",
			// "unit",
		],
		filters: [["email", "=", String(Cookies.get("user_id"))]],
	});
};

export const updateUserDetails = (data: any) => {
	return axios.post(`/api/method/ace_be_app.api.customer.update`, data);
};

export const updatePassword = (data: any) => {
	return axios.get(
		`/api/method/ace_be_app.api.auth.change_password?current_password=${data.current_password}&new_password=${data.new_password}`,
	);
};
